module.exports = __webpack_public_path__ + "img/online.eede6bf4.svg";